<template>
  <div class="Modal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <button
              class="modal-default-button"
              @click="closeModal"
            >
              <svg
                width="45"
                height="45"
              >
                <use
                  href="#icon-close"
                  fill="currentColor"
                />
              </svg>
            </button>
            <slot name="content" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods:{
    closeModal(){
      this.$emit('close')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables";
@import "~bootstrap/scss/mixins/breakpoints";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color-black, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
}

.modal-container {
  position: relative;
  width: 50%;
  padding:40px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba($color-black, 0.33);
  transition: all 0.3s ease;
}

.modal-default-button {
  position: absolute;
  right: 0;
  top:-23px;
  border:0;
  background: transparent;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
